module.exports = __webpack_public_path__ + "static/media/4.24c6069f.png";